var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 font-size-12 text-muted text-left d-flex align-items-center"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"height":"40px"},attrs:{"src":require("@/assets/images/logo-instagram.png")}}),_c('div',{staticClass:"ml-3"},[_vm._v(" EXPANSÃO DROP TECNOLOGIA E TREINAMENTOS LTDA ")])])
}]

export { render, staticRenderFns }